import { render, staticRenderFns } from "./AddressFormats.vue?vue&type=template&id=34c1c300&scoped=true"
import script from "./AddressFormats.vue?vue&type=script&lang=js"
export * from "./AddressFormats.vue?vue&type=script&lang=js"
import style0 from "./AddressFormats.vue?vue&type=style&index=0&id=34c1c300&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c1c300",
  null
  
)

export default component.exports